define('all/player/new-customer',['jquery', 'all/slidingContentWrapper'], function($, slidingContentWrapper) {
	'use strict';

	var nc = {};

	function switchToNormalLogin() {
		nc.hide();
		$('#cnt-login-bar').css('display', 'inline-block');
	}

	function setupRegisterLoginButtons() {
		var $bar = $('#cnt-newcustomer-bar');
		$bar.find('a.register').off('click').on('click', slidingContentWrapper.showSlidingSignup);
		$bar.find('a.login').off('click').on('click', switchToNormalLogin);
	}

	nc.show = function() {
		$('#cnt-newcustomer-bar').css('display', 'inline-block');
		setupRegisterLoginButtons();
	};

	nc.hide = function() {
		$('#cnt-newcustomer-bar').hide();
	};

	return nc;
});


